import { api } from "../../common/config/api";

export const BRAND_URL = {
	getBrands: `${api.withAPI}/v1/catalog/brand`,
	removeBrand: `${api.withAPI}/v1/catalog/brand`,
	editBrand: `${api.withAPI}/v1/catalog/brand`,
	createBrand: `${api.withAPI}/v1/catalog/brand`,
	getBrand: `${api.withAPI}/v1/catalog/brand`,
}